export default __webpack_public_path__ + "static/media/contact_active.a6dfb0bb.png";